export default "__VITE_ASSET__PQNE2cKB__"